var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ExActionsPopUp',{attrs:{"value":_vm.value,"headline":"Retire Checkpoint","htmlInfo":_vm.info,"actionLabel":"Retire","data-testid":"retire-checkpoint-popup","icon":"checkpoint_pass","applyBorderClass":true},on:{"input":function($event){return _vm.$emit('input', $event)},"onAction":function($event){return _vm.$emit('onSave')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }